<template>
    <!-- Dashboard Content
      ================================================== -->
    <div class="dashboard-content-container" data-simplebar :key="key">

        <div :key="`${key}loader`" v-if="status === -1" >
            <loader></loader>
        </div>
        <div :key="`${key}notfound`" v-else-if="status === 0">
            <not-found></not-found>
        </div>


        <div class="dashboard-content-inner" :key="`${key}user`" v-else>
            <!-- Dashboard Headline -->
            <div class="dashboard-headline">
                <h3>Projects</h3>

                <!-- Breadcrumbs -->
                <nav id="breadcrumbs" class="dark">
                    <ul>
                        <!--                   <router-link to="/admin">Admin</router-link>-->
                        <li><a href="/admin">Admin</a></li>
                        <li><a href="/admin/locations/countries">Locations</a></li>
                        <li><a href="#">{{ this.locationType }}</a></li>
                        <li>{{ location.name }}</li>
                        <li>Projects</li>
                    </ul>
                </nav>
            </div>

            <div class="col-xl-12">
                <br/>
                <div class="row">

                    <div class="dashboard-box margin-top-0 col-xl-12">
                        <projects-list :country="country" :region="region" :city="city" :key="`${key}main`">
                        </projects-list>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!--            <app-footer></app-footer>-->
    <!-- Dashboard Content / End -->

</template>

<script>
    import {getCountry, getRegion, getCity} from '../../../../core/services/location-services'
    import Loader from "../../../partials/Loader";
    import NotFound from "../../../pages/NotFound/index";
    import ProjectsList from "./ProjectsList";

    export default {
        name: 'UsersPage',
        components: {ProjectsList, NotFound, Loader},
        data() {
            return {
                status: -1,
                location: '',
                locationType: '',
                country: '',
                region: '',
                city: '',
                key: 3,
            }
        },

        computed: {
        },
        methods: {
            loadCountry(id) {
                getCountry(id)
                    .then((country) => {
                        if(country === "") {
                            this.status = 0;
                        } else {
                            this.location = country;
                            this.country = country;
                            this.status = 1;
                        }
                    })
                    .catch(() => {
                        // console.log(error);
                    })
                    .finally(() => {
                        this.key++;
                    });
            },
            loadRegion(id) {
                getRegion(id)
                    .then((response) => {
                        if(response.data.data === undefined) {
                            this.status = 0;
                        } else {
                            this.location = response.data.data;
                            this.region = response.data.data;
                            this.status = 1;
                        }
                    })
                    .catch(() => {
                        // console.log(error);
                    })
                    .finally(() => {
                        this.key++;
                    });
            },
            loadCity(id) {
                getCity(id)
                    .then((response) => {
                        if(response.data.data === undefined) {
                            this.status = 0;
                        } else {
                            this.location = response.data.data;
                            this.city = response.data.data;
                            this.status = 1;
                        }
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.key++;
                    });
            },
            populateProjectLocation(location,locationId) {

                if(location === "Country") {
                    this.loadCountry(locationId);
                }
                if(location === "Region") {
                    this.loadRegion(locationId);
                }
                if(location === "City") {
                    this.loadCity(locationId);
                }

            },

        },



        created() {
            let locationId = 0;
            if(this.$route.query.country != null) {
                this.locationType = "Country";
                locationId = this.$route.query.country;
            }
            if(this.$route.query.region != null) {
                this.locationType = "Region"
                locationId = this.$route.query.region;
            }
            if(this.$route.query.city != null) {
                this.locationType = "City"
                locationId = this.$route.query.city;
            }

            // this.location
            if(this.locationType === "") {
                this.status = 0
            } else {
                this.populateProjectLocation(this.locationType,locationId);
            }

        }
    };
</script>

<style scoped>
    .country-info {
        font-size: .7rem;
        color: #0fbaf1 !important;
    }
    .country-name {
        text-transform: uppercase;
        color: black;
    }
    .country-name::after {
        content: " ";
    }
    .search-info {
        margin: 0 auto;
        text-align: center;
        color: #0fbaf1 !important;
    }
</style>
